import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=315a13f3&scoped=true"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"
import style0 from "./Status.vue?vue&type=style&index=0&id=315a13f3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315a13f3",
  null
  
)

export default component.exports